<style scoped>
  .donate-page-template{
    background: #fff;
  }
  .donate-container{
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .actions{
    margin-top: 20px;
    width: 100%;
  }
  .cover-photo{
    height: 60px;
    width: 60px;
    background: #d8d8d8;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    margin-right: 10px;
  }
  .group-header{
    display: flex;
  }

  .actions {
    margin-top: 20px;
    width: 100%;
  }

  .actions > .amounts{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
  }

  .amounts > .amount{
    margin-top: 10px;
    margin-right: 5px;
    margin-left: 5px;
  }

  .amount > button{
    min-width: 100px;
  }

  .donate-header {
    background: #eee;
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }

  .donate-body {
    margin-top: 10px;
  }

  .donate-body > .action-buttons{
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: column;
  }

  .card-image{
    height: 30px;
    margin-right: 5px;
  }

  .process-button{
    width: 160px;
  }

  .secured{
    margin-top: 5px;
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
</style>
<style lang="scss">
  .modal-donation{ 
    .ivu-modal-footer {
      display:none !important;
    }
    .ivu-modal-body {
      padding: 16px 16px 12px 16px !important;
    }
  }
</style>
<template>
  <AppLayout class="donate-page-template">
    <Row type="flex" justify="center">
      <Col :span="24" style="padding:15px">
        <div class="donate-container">
          <div class="group-header" v-if="false">
            <div class="cover-photo" v-if="careplan.thumbnail_photo" :style="{ 'background-image': 'url(' + getGroupImage(careplan, 'small') + ')' }">
            </div>
            <h3 style="margin-top:23px">{{careplan.title}}</h3>
          </div>
          <div class="initial-page" v-if="false">
            <div class="donate-header">
              <h3>DONATE TODAY</h3>
              <p>What type of donation do you want to make?</p>
              <div class="secured">
                Secure <Icon type="ios-locked" style="margin-right:5px"></Icon>
              </div>
            </div>
            <div class="donate-body">
              <div class="action-buttons">
                <div class="online-donation" style="text-align: center;margin-bottom: 30px;">
                  <b>Option 1:&nbsp;</b> <Button type="primary" class="process-button"
                  :class="{ active: activeAmount === 1 }" v-on:click="activeAmount = 1">Online Donation</Button>
                  <div v-if="false" class="cards" style="margin-top: 5px;">
                    <img alt=" " src="@/assets/visa.png" class="card-image">
                    <img alt=" " src="@/assets/master-card.png" class="card-image">
                    <img alt=" " src="@/assets/paypal.png" class="card-image">
                  </div>
                </div>
                <div class="direct-deposit">
                  <b>Option 2:&nbsp;</b> <Button type="primary" class="process-button" :class="{ active: activeAmount === 2 }"
                    v-on:click="activeAmount = 2">Direct Deposit</Button>
                </div>
              </div>
            </div>

            <div class="bottom-buttons" style="margin-top: 50px;display: flex;flex-direction: row-reverse;">
              <Button type="primary" v-on:click="showInitialPage = true">Next</Button>
            </div>
          </div>

          <!-- <div class="donate-online" v-if="showInitialPage">
            <OnlinePayment @backToHome="showInitialPage = false"></OnlinePayment>
          </div> -->
          <ModalHolder  :class-name="'modal-donation'" m-top="30" :title="''" :is-show="showInitialPage"
            :mHeight="'65vh'" :closable="false" :mScrollable="'hidden'" @on-close="$router.go(-1) ">
            <template slot="mheader">
              <!-- <div class="donate-header"> -->
                <div class="group-header" style="position:relative;margin-right:0px">
                  <div class="cover-photo" v-if="careplan.thumbnail_photo" :style="{ 'background-image': 'url(' + getGroupImage(careplan, 'small') + ')' }">
                  </div>
                  <h3 style="margin-top:25px">{{careplan.title}}</h3>
                  <div class="secured" style="position:absolute;right:0;bottom:0">
                    Secure <Icon type="ios-locked" style="margin-right:5px"></Icon>
                  </div>
                  <img alt=" " @click="closeDonate()" style="height:25px; width:25px; margin-left:auto;margin-top:-5px;margin-right:-6px" src="@/assets/close.png">
                </div>
              <!-- </div> -->
            </template>
            <template slot="mcontent">
              <OnlinePayment @backToHome="showInitialPage = false" @on-close="$router.go(-1)">
              </OnlinePayment>
            </template>
          </ModalHolder>

          <div class="direct-deposit">
          </div>
        </div>
      </Col>
    </Row>
  </AppLayout>
</template>

<script>
  import OnlinePayment from '@/components/OnlinePaymentComponent'
  import ModalHolder from "@/components/ModalHolderComponent";
  import Utils from '@/utils.js'

  const methodsMixin = {
    methods: {
      closeDonate: function()  {
        this.showInitialPage=false;
        this.$router.go(-1);
        console.log('closeDonate...');
      }
    }
  }

  export default {
    name: "DonateComponent",
    mixins:[methodsMixin],
    data(){
      return {
        amounts: ['500', '1,000', '2,500', '5,000', '10,000', '25,000'],
        amount: null,
        showInitialPage: true,
        activeAmount: null,
        showNextStep: true,
      }
    },
    watch: {
      activeAmount: function(n, o){
        console.log(o)
        if(n){
          this.showNextStep = true
        }else{
          this.showNextStep = false
        }
      }
    },
    components: {
      OnlinePayment,
      ModalHolder
    },
     computed: {
      careplanId: {
        get () {
          return this.$route.query.rid
        }
      },
      careplan: {
        get () {
          return this.$store.state.resource.singleResource.data
        }
      }
    },
    watch: {
      $route: function (n, o) {
        this.$store.dispatch('resource/getSingleResource', {id: this.careplanId});
      }
    },
    methods: {
      getGroupImage(data, size) {
        return Utils.getDisplayImage('group', data, size)
      }
    },
    mounted(){
      if(this.careplanId){
        this.$store.dispatch('resource/getSingleResource', {id: this.careplanId});
        this.showInitialPage = true;
      }
    }
  }
</script>

